<template>
  <div class="search_filter_right flex-r-sa-c">
    <div v-if="type === 2 || type === 3|| type === 4"
         :class="search_filter_tab === 5?'search_filter_item flex-r-c-c search_filter_active' : 'search_filter_item flex-r-c-c'"
         @click="changeFilter(5)"
    >
      <span style="font-size: 0.32rem;">分类筛选</span>
      <van-image v-if="saleNum === 51" width="0.32rem" height="0.37rem"
                 src="https://hxxxkj-oss-cdn.xiaoyi120.com/sysx-xcx/mall/filter2_2.svg"
      />
      <van-image v-else width="0.32rem" height="0.37rem"
                 src="https://hxxxkj-oss-cdn.xiaoyi120.com/sysx-xcx/mall/filter2_1.svg"
      />
    </div>
    <div v-if="showPopup2 && type > 1 && saleNum === 51" class="tab_category_popup flex-r-s-s">
      <div :class="tab4 === '' ? 'popup_item popup_active':'popup_item'" @click="clickTabcategory('')">
        全部</div>
      <div v-for="(category,index_category) in mallCategoryList" :key="index_category"
           :class="tab4 === category.categoryId ? 'popup_item popup_active':'popup_item'"
           @click="clickTabcategory(category.categoryId)"
      >{{ category.title }}</div>
    </div>
  </div>
</template>

<script>
import { searchMallProductCategoryBrand, searchMallProductCategoryBrandAgency, mallPreferential_brandList } from '@/api/pro'
export default {
  props: {
    name: { type: String, default: '' },
    cid: { type: String, default: '' },
    tagid: { type: String, default: '' },
    mid: { type: String, default: '' },
    type: { type: Number, default: 1 },
    showtag: { type: Boolean, default: true },
    wholesaleAgentBrandId: { type: String, default: '' },
    agency: { type: Boolean, default: false }
  },
  data() {
    return {
      search_filter_tab: 0,
      issaleNum: false,
      saleNum: 21,
      isprice: false,
      price: 31,
      popupName: '全部商品',
      showPopup: false,
      showPopup2: false,
      showPopup3: false,
      showPopup4: false,
      tab4: 41,
      popupTitle: '',
      mallCategoryList: [],
      brandList: [],
      search_filter_pupop: false,
      popup_box_tag: 0,
      popup_box_brand_list: [],
      brand_list_choosed: ['']
    }
  },
  methods: {
    // 顶部搜索切换
    changeFilter(index) {
      this.search_filter_tab = index
      if (index === 1) {
        this.isprice = false
        this.issaleNum = false
        this.saleNum = 21
        this.price = 31
        this.$emit('changeFilter', index)
      }
      if (index === 2) {
        this.issaleNum = !this.issaleNum
        this.saleNum = this.issaleNum ? 22 : 23
        this.isprice = false
        this.price = 31
        this.$emit('changeFilter', index)
      }
      if (index === 3) {
        this.isprice = !this.isprice
        this.price = this.isprice ? 32 : 33
        this.issaleNum = false
        this.saleNum = 21
        this.$emit('changeFilter', index)
      }
      if (index === 4) {
        this.showPopup = !this.showPopup
        this.showPopup2 = false
        this.$emit('changeFilter', index)
      }
      if (index === 5) {
        this.saleNum = 51
        this.showPopup = false
        this.showPopup2 = !this.showPopup2
        if (this.agency) {
          searchMallProductCategoryBrandAgency({ page: 1, limit: 9999, wholesaleAgentBrandId: this.wholesaleAgentBrandId }).then(res => {
            this.mallCategoryList = res.data.list
          })
        } else {
          searchMallProductCategoryBrand({ proName: this.name, proCategoryId: this.cid, tagId: this.tagid, mallProductModuleId: this.mid }).then(res => {
            this.mallCategoryList = res.data.categoryList
          })
        }
      }
      if (index === 6) {
        this.saleNum = 61
        this.showPopup = false
        this.showPopup3 = !this.showPopup3
        searchMallProductCategoryBrand({ proName: this.name, proCategoryId: this.cid, tagId: this.tagid, mallProductModuleId: this.mid }).then(res => {
          this.brandList = res.data.brandList
        })
      }
      if (index === 7 && this.showtag) { // 侧面popup
        this.showPopup4 = true
        this.popup_box_brand_list = []
        console.log('brand_list_choosed', this.brand_list_choosed)
        searchMallProductCategoryBrand({ proName: '', proCategoryId: this.cid, tagId: this.tagid, mallProductModuleId: '' }).then(res => {
          var brandCopyList = []
          for (var i = 0; i < res.data.brandList.length; i++) {
            brandCopyList.push({ name: res.data.brandList[i], checked: false })
            for (var j = 0; j < this.brand_list_choosed.length; j++) {
              if (this.brand_list_choosed[j] === res.data.brandList[i]) {
                this.$set(brandCopyList[i], 'checked', true)
                break
              }
            }
          }
          this.popup_box_brand_list = brandCopyList
          console.log('popup_box_brand_list', this.popup_box_brand_list)
        })
      }
      if (index === 7 && !this.showtag) { // 侧面popup
        this.showPopup4 = true
        this.popup_box_brand_list = []
        console.log('brand_list_choosed', this.brand_list_choosed)
        mallPreferential_brandList({ proName: '', proCategoryId: this.cid }).then(res => {
          var brandCopyList = []
          for (var i = 0; i < res.data.length; i++) {
            brandCopyList.push({ name: res.data[i], checked: false })
            for (var j = 0; j < this.brand_list_choosed.length; j++) {
              if (this.brand_list_choosed[j] === res.data[i]) {
                this.$set(brandCopyList[i], 'checked', true)
                break
              }
            }
          }
          this.popup_box_brand_list = brandCopyList
          console.log('popup_box_brand_list', this.popup_box_brand_list)
        })
      }
    },
    clickpopupBrand(item) {
      item.checked = !item.checked
      if (item.checked) {
        this.brand_list_choosed.push(item.name)
        console.log('brand_list_choosed 0', this.brand_list_choosed)
      } else {
        console.log('item.name', item.name)
        console.log('brand_list_choosed 1', this.brand_list_choosed)
        for (const i in this.brand_list_choosed) {
          if (this.brand_list_choosed[i] === item.name) {
            this.brand_list_choosed.splice(i, 1)
          }
        }
      }
      console.log('brand_list_choosed 2', this.brand_list_choosed)
    },
    clickpopupTab(index) {
      this.brand_list_choosed = ['']
      this.popup_box_tag = index
      if (index === 0) this.tagid = ''
      if (index === 1) this.tagid = '282'
      if (index === 2) this.tagid = '281'
      if (index === 3) this.tagid = '275'
      searchMallProductCategoryBrand({ proName: '', proCategoryId: this.cid, tagId: this.tagid, mallProductModuleId: '' }).then(res => {
        var brandCopyList = []
        for (const i in res.data.brandList) {
          brandCopyList.push({ name: res.data.brandList[i], checked: false })
        }
        this.popup_box_brand_list = brandCopyList
      })
    },
    confirmPopup() {
      this.showPopup4 = false; this.search_filter_pupop = true
      this.$emit('popupSearch', { tagId: this.tagid, proBrands: this.brand_list_choosed.length === 1 ? [] : this.brand_list_choosed })
    },
    resetPopup() {
      this.brand_list_choosed = []
      this.showPopup4 = false; this.search_filter_pupop = false
      this.$emit('popupSearch', { tagId: this.tagid, proBrands: this.brand_list_choosed })
    },
    clickTab(index) {
      this.tab4 = index
      this.showPopup = false
      if (index === 41) this.popupName = '全部商品'
      if (index === 42) this.popupName = '超值通货'
      if (index === 43) this.popupName = '严选实惠自用'
      if (index === 44) this.popupName = '严选零售创收'
      this.$emit('changeFilter', index)
    },
    clickTabcategory(id) {
      this.tab4 = id
      this.showPopup2 = false
      this.$emit('changeFiltercategory', id)
    },
    clickTabbrand(brand) {
      this.tab4 = brand
      this.showPopup3 = false
      this.$emit('changeFilterbrand', brand)
    },
    rightTitle(title) {
      console.log('title', title)
      this.popupTitle = title
    },
    // 关闭展示
    closePullBox() {
      this.showPopup = false; this.showPopup2 = false; this.showPopup3 = false
      this.brand_list_choosed = ['']; this.popup_box_tag = 0; this.tagid = ''
      this.showPopup4 = false; this.search_filter_pupop = false
    }
  }
}
</script>

<style>
.search_filter .van-popup {
  border-top-left-radius: 0.26rem;
  border-bottom-left-radius: 0.26rem;
  border-top-right-radius: 0rem;
  border-bottom-right-radius: 0rem;
}
.popup_box {
  padding: 0.43rem;
  position: relative;
}
.popup_box .title {
  font-weight: 700;
  font-size: 0.37rem;
  text-align: left;
  color: #333;
  margin-bottom: 0.2rem;
}
.popup_buttom {
  position: fixed;
  height: 1rem;
  width: 100%;
  bottom: 0;
  background: #fff;
  padding-bottom: 0.3rem;

  padding-bottom: 0.5rem;
  padding-top: 0.5rem;

  z-index: 99;
}
.popup_buttom .popup_buttom_box {
  width: 7.95rem;
  height: 1.17rem;
  border-radius: 0.59rem;
  background: #fff;
  border: 0.03rem solid #0767ab;

  line-height: 1.17rem;
}
.popup_buttom .popup_buttom_box .left_bottom {
  width: 3.97rem;
  height: 1.17rem;
  border-radius: 0.59rem 0 0 0.59rem;
  background: #fff;

  font-weight: 400;
  font-size: 0.37rem;
  color: #0767ab;
}
.popup_buttom .popup_buttom_box .right_bottom {
  width: 3.97rem;
  height: 1.17rem;
  border-radius: 0 0.59rem 0.59rem 0;
  background: #0767ab;

  font-weight: 400;
  font-size: 0.43rem;
  color: #fff;
}
</style>
